import { useQuery } from '@apollo/client';
import { GET_ORDER } from '@monofront/business/queries';
import HeartLoader from '@monofront/design-system/components/HeartLoader';
import { OrderBody } from '@screens/Order/OrderBody';
import { useContext, useEffect } from 'react';
import { LayoutContext } from '@context/LayoutContext';
import { useTranslations } from 'use-intl';

interface IOrderProps {
  id: string;
}

export const Order: React.FC<IOrderProps> = ({ id }) => {
  const { data, loading } = useQuery(GET_ORDER, {
    variables: {
      id: id,
    },
    ssr: false,
    fetchPolicy: 'cache-and-network',
  });
  const order = data?.getOrder;
  const { setCustomTitleHeaderMobile } = useContext(LayoutContext);

  const tAccount = useTranslations('Account');

  useEffect(() => {
    if (order?.name) {
      setCustomTitleHeaderMobile!(
        tAccount('orderName', { orderName: order.name }),
      );
    }
  }, [order]);

  if (loading) {
    return (
      <div className="loader">
        <HeartLoader />
      </div>
    );
  }

  return (
    <>
      <div className="order">
        {order ? (
          <OrderBody order={order} />
        ) : (
          <div className="error-container">
            <p className="error tw-lf-error-message">
              {tAccount('orderNotFound')}
            </p>
          </div>
        )}
      </div>
      <style jsx>{`
        .order {
          width: 100%;
        }

        .error-container {
          text-align: center;
        }
        .loader {
          display: flex;
          justify-content: center;
        }

        @media (max-width: 800px) {
          .order {
            min-height: calc(
              100vh - var(--mobile-header-minheight) - var(--space-6) - 60px
            );
          }
        }
      `}</style>
    </>
  );
};
